import PostExcelForAdminRequestModelBase from '../_generated/modelBases/post-excel-for-admin-request-model-base';

export default class PostExcelForAdminRequestModel extends PostExcelForAdminRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
